import { Sparkle } from "@phosphor-icons/react";

const ITEMS = [
  "Medical Coverage",
  "Term Life Protection",
  "Motor Insurance",
  "Pension & Retirement",
  "Home Loans",
  "Commercial Property Loans",
  "Claim-Time Support",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section className="bg-sage border-y border-forest/5 py-10 overflow-hidden" data-testid="marquee-section" aria-hidden="true">
      <div className="flex w-max animate-marquee items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-8 pr-8">
                <span className="font-serif italic text-3xl md:text-4xl text-forest/35 whitespace-nowrap">{item}</span>
                <Sparkle size={16} weight="fill" className="text-mint/60 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
